export const DEFAULT_TRANSLATIONS = {
  quantity: 'Quantity',
};

export type Translations = typeof DEFAULT_TRANSLATIONS;
export type TranslationKey = keyof typeof DEFAULT_TRANSLATIONS;
export type TranslationKeys = {
  [key in TranslationKey]: key;
};

/**
 * Use this object to access the particular message ID / key.
 */
export const translationKeys = Object.fromEntries(
  Object.keys(DEFAULT_TRANSLATIONS).map((cur) => [cur, cur]),
) as TranslationKeys;
